// extracted by mini-css-extract-plugin
module.exports = {"root":"icon_root__3XlPj","icon":"icon_icon__CLAl6"};